import React from "react";
import { trackLandingPageCTA } from "../utils/analytics";
import { trackCTAClick } from "../config/gtm";

type Props = {
  children: React.ReactNode;
  as?: "button" | "a";
  href?: string;
  onClick?: () => void;
  className?: string;
  ctaName?: string; // Nombre del CTA para tracking
  section?: string;  // Sección donde está el CTA
};

export default function CTAButton({ 
  children, 
  as = "button", 
  href, 
  onClick, 
  className,
  ctaName,
  section 
}: Props) {
  const Comp: any = as === "a" ? "a" : "button";
  
  const handleClick = () => {
    // Tracking del CTA click con Google Analytics (existente)
    if (ctaName && section) {
      trackLandingPageCTA(ctaName, section);
    } else if (ctaName) {
      trackLandingPageCTA(ctaName, 'Unknown Section');
    } else {
      trackLandingPageCTA(children?.toString() || 'Unknown CTA', 'Unknown Section');
    }
    
    // Tracking adicional con Google Tag Manager
    const finalCtaName = ctaName || children?.toString() || 'Unknown CTA';
    const finalSection = section || 'Unknown Section';
    trackCTAClick(finalCtaName, finalSection, as || 'button');
    
    // Lógica original del onClick
    onClick?.();
  };
  
  return (
    <Comp
      href={href}
      onClick={handleClick}
      className={`
        inline-flex items-center justify-center
        px-6 py-4 sm:px-8 sm:py-5 lg:px-10 lg:py-6
        text-base sm:text-lg lg:text-xl xl:text-2xl
        font-bold text-white
        bg-gradient-to-r from-yellow-500 to-orange-500
        hover:from-yellow-600 hover:to-orange-600
        focus:outline-none focus:ring-4 focus:ring-yellow-300
        rounded-xl sm:rounded-2xl lg:rounded-3xl
        shadow-lg hover:shadow-xl
        transform hover:scale-105
        transition-all duration-300 ease-in-out
        w-full sm:w-auto
        min-h-[56px] sm:min-h-[64px] lg:min-h-[72px]
        ${className || ""}
      `}
      type={as === "button" ? "button" : undefined}
    >
      {children}
    </Comp>
  );
}